import {
  Box,
  Container,
  Heading,
  HStack,
  Stack,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  CircularProgress,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Card, { getCardScheme } from "components/Card/Card";
// import PinInput from "components/Input/PinInput";
import Button from "components/Button/Button";
// import Select from "components/Select/Select";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import Confirmation from "components/Modals/p2p/Confirmation";

import MyCardDetails from "./MyCardDetails";
import MyCardTransactions from "./MyCardTransactions";

import { useParams, useHistory, useLocation } from "react-router-dom";

import { useCallback, useMemo, useEffect, useState } from "react";
import {
  useGetUserCardsQuery,
  // useGetUserCardDetailQuery,
  useFreezeUserCardMutation,
  useLiquidateCardMutation,
  // useGetUserCardDetailMutation,
} from "services/cardsApi";
import getError from "util/getError";
import { toQueryString } from "util/utils";
import SubmitPin from "components/Modals/SubmitPin";
import useCardDetails from "hooks/useCardDetails";
// import { isObject } from "lodash";

import ls from "util/secureStorage";
import constant from "config/constant";

export const CustomTab = (props) => (
  <Tab
    borderRadius="6px"
    py="6px"
    fontSize="14px"
    fontWeight="600"
    color="#4E4B66"
    mb="0"
    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
    _selected={{ bg: "white", color: "#14142B" }}
    {...props}
  >
    {props.children}
  </Tab>
);

const MyCard = (props) => {
  const currentPage = "Card";

  const location = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(location?.search), [location]);

  const [state, setState] = useState({});

  const handleState = (newState) => {
    setState({ ...state, ...newState });
  };

  const tempPin = useMemo(() => state?.pin ?? ls.get(constant.TEMP_PIN), [state?.pin]);

  const resetPin = () => {
    handleState({ ...state, pin: null });
  };

  // console.log(
  //   "LOCATION",
  //   searchParams.toString(),
  //   searchParams.get("provider"),
  //   searchParams.get("version")
  // );

  const { id } = useParams();
  const history = useHistory();
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isFundUnsupportedOpen,
    onClose: onFundUnsupportedClose,
    onOpen: onFundUnsupportedOpen,
  } = useDisclosure();
  const { isOpen: isLiquidationOpen, onClose: onLiquidationClose, onOpen: onLiquidationOpen } = useDisclosure();

  const { data: userCardsData, isFetching: isGettingAllCards } = useGetUserCardsQuery();

  const queries = useMemo(() => toQueryString({ p: searchParams.get("provider") }), [searchParams]);
  console.log("QUERIES", queries);

  const { card, isFetching, isPinOpen, onPinClose } = useCardDetails(id, tempPin, { queries }, resetPin);

  // const card = useMemo(
  //   () => location?.state?.card ?? details,
  //   [location?.state?.card, details]
  // );

  // const { data, isFetching } = useGetUserCardDetailQuery({ id, queries });
  // const [getCardDetails, { data, isLoading: isFetching }] =
  //   useGetUserCardDetailMutation({ id, queries });

  // useEffect(() => {
  //   if (!state?.pin || (!!state?.pin && state?.pin?.length < 6)) onPinOpen();
  //   else getCardDetails({ id, queries, pin: state?.pin });
  // }, [state?.pin, getCardDetails, id, queries, onPinOpen]);

  const [freezeCard, { isLoading: isFreezingCard, isSuccess, isError, error, data: freezeCardData }] =
    useFreezeUserCardMutation();

  const [
    liquidateCard,
    { isLoading: isLiquidating, isSuccess: isLiqSuccess, isError: isLiqError, error: liqError, data: liqData },
  ] = useLiquidateCardMutation();

  const currentCard = useMemo(() => userCardsData?.data?.card?.find((c) => c.cardId === id), [userCardsData, id]);

  const getCardColorScheme = useCallback(() => {
    return getCardScheme(currentCard?.cardType?.type);
  }, [currentCard]);

  // const card = useMemo(() => data?.data, [data]);

  const canPerformAction = useMemo(() => {
    return {
      withdraw:
        (currentCard?.cardVersion === "v3" &&
          currentCard?.provider === "p2" &&
          +currentCard?.balance?.$numberDecimal > 0) ||
        ((currentCard?.provider ?? "p1") === "p1" && +card?.balance > 0),
      fund: currentCard?.cardVersion === "v3" && currentCard?.provider === "p2",
      freeze: currentCard?.cardVersion === "v3" && currentCard?.provider === "p2",
      liquidate: (currentCard?.provider ?? "p2") === "p2" && currentCard?.cardVersion === "v2",
    };
  }, [currentCard, card]);

  console.log("CARD DETAIL", card);
  console.log({ currentCard });

  // const userCard = useMemo(
  //   () => cardOptions.find((card) => card.id === id),
  //   [id]
  // );

  // const toggleCardFreeze = () => {
  //   card?.frozen && unfreezeCard(id);
  //   !card?.frozen && freezeCard(id);
  // };

  const handleFreezeCard = () => {
    onClose();
    freezeCard(id);
  };

  const handleLiquidation = () => {
    liquidateCard({ id });
    onLiquidationClose();
  };

  const handleFund = () => {
    if (!canPerformAction.fund) {
      onFundUnsupportedOpen();
    } else {
      history.push(`/dashboard/cards/${id}/fund?provider=${currentCard?.provider ?? "p1"}`, { card });
    }
  };

  useEffect(() => {
    if (isSuccess && freezeCardData) {
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Card has been successfully frozen",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

      history.replace("/dashboard/cards");
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, freezeCardData, isError, toast, history]);

  useEffect(() => {
    if (isLiqSuccess && liqData) {
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Card has been successfully liquidated",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

      history.replace("/dashboard/cards");
    }

    if (isLiqError && liqError) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(liqError?.data?.error),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [isLiqSuccess, liqError, liqData, isLiqError, toast, history]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box className="page-container" p={["6em 0 !important", "6.5em 1.5em !important"]}>
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Cards</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/cards">Cards</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    My Card
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              w="calc(100% - 25vw)"
              //   w="100%"
              mt="32px"
              borderRadius="8px"
              p="24px"
            >
              <VStack maxW="xs" m="0 auto">
                <Stack>
                  <Card
                    showBalance
                    isLoading={isFetching || isGettingAllCards}
                    balance={card?.balance}
                    currency={card?.currency}
                    number={card?.cardNumber}
                    // name={card?.cardName}
                    name={card?.nameOnCard ?? card?.cardName}
                    // validity={card?.valid}
                    validity={card?.expiry ?? card?.valid}
                    colorScheme={getCardColorScheme()}
                    brand={card?.brand}
                  />

                  {(isFetching || isGettingAllCards) && (
                    <CircularProgress alignSelf="center" disabled isIndeterminate color="var(--primary)" size="22px" />
                  )}

                  {!(!!isFetching && !!isGettingAllCards) && (
                    <>
                      <HStack mt="32px !important">
                        {card && canPerformAction.withdraw && (
                          <Button
                            bg="#f6e6e6"
                            color="#ff6262"
                            borderRadius="5px"
                            h="50px"
                            p="12px 44px"
                            flex="1"
                            _hover={{ shadow: "0 0 0 3px #f565659f" }}
                            _active={{ shadow: "0 0 0 3px #f565659f" }}
                            _focus={{ shadow: "0 0 0 3px #f565659f" }}
                            onClick={() =>
                              history.push(
                                `/dashboard/cards/${id}/withdraw?provider=${currentCard?.provider ?? "p1"}`,
                                { card }
                              )
                            }
                            disabled={isFetching || isGettingAllCards}
                          >
                            Withdraw
                          </Button>
                        )}
                        {card && canPerformAction.liquidate && (
                          <Button
                            bg="#f6e6e6"
                            color="#ff6262"
                            borderRadius="5px"
                            h="50px"
                            p="12px 44px"
                            flex="1"
                            _hover={{ shadow: "0 0 0 3px #f565659f" }}
                            _active={{ shadow: "0 0 0 3px #f565659f" }}
                            _focus={{ shadow: "0 0 0 3px #f565659f" }}
                            onClick={onLiquidationOpen}
                            isLoading={isLiquidating}
                            disabled={isFetching || isGettingAllCards || isLiquidating}
                          >
                            Liquidate
                          </Button>
                        )}
                        {card && (currentCard?.provider === "p2" || canPerformAction.fund) && (
                          <Button
                            bg="#E6F6EB"
                            color="var(--primary)"
                            borderRadius="5px"
                            h="50px"
                            p="12px 44px"
                            flex="1"
                            onClick={handleFund}
                            disabled={isFetching || isGettingAllCards}
                          >
                            Fund
                          </Button>
                        )}
                      </HStack>
                      <Tabs isFitted mt="26px !important">
                        <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                          <CustomTab>Details</CustomTab>
                          <CustomTab>Transactions</CustomTab>
                        </TabList>

                        <TabPanels>
                          <TabPanel px="0">
                            <MyCardDetails
                              isLoading={isFetching}
                              details={card}
                              provider={searchParams.get("provider") ?? "p1"}
                            />

                            {card && canPerformAction.freeze && (
                              <Button
                                isLoading={isFreezingCard}
                                disabled={isFreezingCard}
                                w="100%"
                                minH="64px"
                                mt="20px !important"
                                bg="red.500"
                                _hover={{ shadow: "0 0 0 3px #f56565" }}
                                _active={{ shadow: "0 0 0 3px #f56565" }}
                                _focus={{ shadow: "0 0 0 3px #f56565" }}
                                onClick={onOpen}
                              >
                                Freeze Card
                              </Button>
                            )}
                          </TabPanel>
                          <TabPanel px="0">
                            <MyCardTransactions id={id} />
                          </TabPanel>
                        </TabPanels>
                      </Tabs>
                    </>
                  )}
                </Stack>
              </VStack>
            </Box>
          </Container>
        </Box>
      </Box>

      <Confirmation isOpen={isOpen} onClose={onClose} onConfirm={handleFreezeCard} title="Confirm Card Freeze">
        <VStack>
          <Text>Are you sure you want to freeze this card?</Text>
        </VStack>
      </Confirmation>

      <Confirmation
        isOpen={isFundUnsupportedOpen}
        onClose={onFundUnsupportedClose}
        onConfirm={onFundUnsupportedClose}
        title="Fund Card"
        buttonText={["Cancel", "Ok"]}
      >
        <VStack>
          <Text>Funding for old cards disabled. Please create a new card</Text>
        </VStack>
      </Confirmation>

      <Confirmation
        isOpen={isLiquidationOpen}
        onClose={onLiquidationClose}
        onConfirm={handleLiquidation}
        title="Confirm Liquidation"
        buttonText={["Cancel", "Confirm"]}
      >
        <VStack>
          <Text>Please confirm liquidation of all funds on card to be moved into your USDT wallet.</Text>
        </VStack>
      </Confirmation>

      <SubmitPin
        isOpen={isPinOpen}
        onClose={onPinClose}
        // onPin={(pin) => handleState({ pin })}
        onSubmit={(pin) => handleState({ pin })}
        closeOnSubmit
        closable={false}
      />
    </Box>
  );
};

export default MyCard;
